// extracted by mini-css-extract-plugin
module.exports = {"container":"_1bp8dZDeM279faqdw16r4H"};